<div class="clause-row">
    <div class="clause-col-name">{{data.name}}</div>
    <div class="clause-col-desc">{{data.description}}</div>
</div>
